export { Button, buttonClasses, type ButtonSize, type ButtonVariant } from './Button'
export { Dialog } from './Dialog'
export { Field, Textarea } from './Field'
export { AiIcon } from './AiIcon'
export { Marca } from './Marca'
export { Menu, MenuItem } from './Menu'
export { Badge, Banner, Card, type Tone } from './Surfaces'
export {
  CardsSkeleton,
  EmptyState,
  ErrorState,
  GallerySkeleton,
  Progress,
  Skeleton,
} from './States'
export { cx, type ClassValue } from './cx'

/*
 | Iconos.
 |
 | `lucide-react` en vez de los emojis que había (📁 📊 ⚙️ 🖼️ ★ ☆ ✕ ☰ ⋯). No es
 | gusto: un emoji lo dibuja el sistema operativo, así que se ve distinto en
 | cada móvil, no hereda `currentColor` —o sea que no cambia con el tema, que es
 | justo lo que estamos construyendo— y no escala con la tipografía. Además
 | pesan: cada emoji son 2-4 bytes de fuente del sistema pero rompen la línea
 | base del texto que los rodea.
 |
 | Se importan por nombre y el árbol se sacude solo: sólo entra en el bundle el
 | icono que se usa (~0,4 KB cada uno).
 |
 | Convención: `size={18}` en línea con texto, `size={22}` suelto, y
 | `strokeWidth={1.75}` siempre — el 2 por defecto de Lucide se ve tosco a los
 | tamaños pequeños que usa el panel.
 */
export const ICON_STROKE = 1.75
